import { Injectable } from '@angular/core';
var SecureStorage = require('secure-web-storage');
var CryptoJS = require("crypto-js");
import config from '../../assets/config.json';
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  public configvalue = config.inputvalue;
  // public encvalue = key;
  constructor() { }

  public secureStorage = new SecureStorage(localStorage, {
    hash: function hash(key: any): any {
      key = CryptoJS.SHA256(key, this.configvalue.toString()+"90");
      return key.toString();
    },
    encrypt: function encrypt(data: any) {
      data = CryptoJS.AES.encrypt(data, this.configvalue.toString()+"90");
      data = data.toString();
      return data;
    },
    decrypt: function decrypt(data: any) {
      data = CryptoJS.AES.decrypt(data, this.configvalue.toString()+"90");
      data = data.toString(CryptoJS.enc.Utf8);
      return data;
    }
  });
}
